import { Component, OnInit } from '@angular/core';
import { PassDataService } from '../../services/pass-data.service';
import { SlokaTypeLogicService } from '../../logic/sloka-type.service';
import { SlokaLogicService } from '../../logic/sloka.service';
import { DashboardLogicService } from '../../logic/dashboard.service';
import { SlokaTypeModel } from '../../interfaces/interfaces';
import { Observable, combineLatest, forkJoin, of, BehaviorSubject } from 'rxjs';
import {
  map,
  switchMap,
  mergeAll,
  first,
  flatMap,
  filter,
  exhaustMap,
  take,
} from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';

@Component({
  selector: 'sloka-types-list-pg',
  templateUrl: './sloka-types-list.component.html',
})
export class SlokaTypesListPage implements OnInit {
  slokaTypesList$: Observable<SlokaTypeModel[]> = new Observable<
  SlokaTypeModel[]
  >();

  deleteSlokaTypeId: string = '';

  page: number = 1;

  constructor(
    private passDataService: PassDataService,
    private slokaTypeLogicService: SlokaTypeLogicService,
    private slokaLogicService: SlokaLogicService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.slokaTypesList$ = this.passDataService.getAllSlokaTypes();
  }

  onAddButtonClick() {
    this.router.navigate(['/page/add-sloka-type'], {
      state: { isAdd: true, isEdit: true, isView: false },
    });
  }

  receivedAction(e: any) {
    //console.log("data recieved ", e)
    e.isAddSloka &&
      this.router.navigate(['/page/add-sloka/'], {
      state: {
        isAddSloka: true,
        isAdd: true,
        isEdit: true,
        isView: false,
        data: e.data,
      },
    });

    e.isEdit &&
      this.router.navigate([`/page/sloka-type/${e.data.title}`], {
      state: {
        isAddSloka: false,
        isAdd: false,
        isEdit: true,
        isView: false,
        data: e.data,
      },
    });

    e.isView &&
      this.router.navigate([`/page/sloka-type/${e.data.title}`], {
      state: {
        isAddSloka: false,
        isAdd: false,
        isEdit: false,
        isView: true,
        data: e.data,
      },
    });

    e.isDelete &&
      this.passDataService.setPopup({
      isPopup: true,
      message: 'Are you sure to delete this Sloka Type?',
      isOk: false,
      isDelete: true,
      response: '',
    });

    e.isDelete &&
      this.passDataService
    .getPopupAction()
    .pipe(
      filter((a) => {
        return (a != '' || a != null || typeof a != 'undefined');
      }),
      map((b) => b == 'delete'),
      filter((c) => c),
      switchMap((d) =>
                this.slokaTypeLogicService.slokaTypeAndItsSlokasDeleteLogic(e)
               ),
               take(1)
    )
    .subscribe((v: any) => {
      v.message == 'slokatype deleted succesfully' &&
        this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe() &&
        this.passDataService.setPopup({
        isPopup: true,
        message: 'Sloka Type and its slokas are deleted successfully!',
        isOk: true,
        isDelete: false,
        response: '',
      });
    });
  }
}
